import { Value } from '@angular/fire/remote-config';
import { signalStore, withMethods } from '@ngrx/signals';
import { withEntities } from '@ngrx/signals/entities';
import { withActions, withSelectors } from '../../lib/domains/store/ngxs-ngrx.mapper';
import { withRequestStatus } from '../../lib/domains/store/request-status.feature';
import { RemoteConfigActions } from './remote-config.action';
import { RemoteConfigState } from './remote-config.state';
import { computed, Signal } from '@angular/core';

export interface RemoteConfigStateModel {
  remoteConfig: Record<string, Value> | null;
}

export const RemoteConfigStore = signalStore(
  { protectedState: false },

  // withState<RemoteConfigStateModel>({
  //   remoteConfig: null,
  // }),
  withEntities<RemoteConfigStateModel>(),
  withRequestStatus(),
  withSelectors({
    remoteConfig: RemoteConfigState.remoteConfig,
    providerDataWithIsVerified: RemoteConfigState.providerDataWithIsVerified,
  }),
  // Actions
  withActions({
    setRemoteConfigs: RemoteConfigActions.SetRemoteConfig,
    deleteRemoteConfigs: RemoteConfigActions.DeleteRemoteConfigs,
    updateRemoteConfig: RemoteConfigActions.UpdateRemoteConfig,
  }),
  withMethods((store) => ({
    getValue: (configName: string): Signal<Value> =>
      computed(() => (store.remoteConfig() as Record<string, Value>)?.[configName]),
    /**
     * For flags used as conditions. `getValue` hands back a Firebase `Value` object, which is
     * truthy even when the flag is `false`, so `*ngIf` on it shows the feature for everyone. An
     * absent key reads as false, matching Remote Config's own default for a missing boolean.
     */
    getBooleanValue: (configName: string): Signal<boolean> =>
      computed(() => (store.remoteConfig() as Record<string, Value>)?.[configName]?.asBoolean() ?? false),
  })),
  // withComputed((store) => ({
  //   providerDataWithIsVerified: computed(() => {store.remoteConfig().prov..}),
  // }))
  // withMethods((store) => ({
  //   findLocalRemoteConfigByName: (name: Signal<string>): Signal<RemoteConfigStoreModel | undefined> =>
  //     computed(() => {
  //       return store.remoteConfigs().find((x) => (x.remoteConfigPropForm.partner as PartnerData).name == name()); //             .findIndex(p => p.name == name()) >= 0;
  //     }),
  // })),
  // withHooks({
  //   onInit(
  //     { remoteConfigsCount },
  //     actions$ = inject(Actions),
  //     destroyRef = inject(DestroyRef),
  //     toastrService = inject(NbToastrService)
  //   ): void {
  //     actions$
  //       .pipe(
  //         ofActionSuccessful(RemoteConfigActions.SaveRemoteConfig),
  //         tap({
  //           next: () => {
  //             toastrService.info(`RemoteConfig Saved! - ${remoteConfigsCount()}`, 'Saved');
  //           },
  //         }),
  //         takeUntilDestroyed(destroyRef)
  //       )
  //       .subscribe();
  //   },
  // })
);
